<template>
    <div class="float-left mr-1">
        <span :class="`text-${cor}`">
            <i
                :class="`fa ${icone} fa-lg icon-button`"
                :title="titulo"
                @click.stop="exibirEventoseConsultorias()"
            ></i>
        </span>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        acao: {
            type: Object,
            default: () => ({})
        },

        titulo: {
            type: String,
            default: () => 'Metas'
        },

        icone: {
            type: String,
            default: () => 'fa-bars'
        },

        cor: {
            type: String,
            default: () => 'primary'
        }
    },

    data() {
        return {}
    },

    methods: {
        exibirEventoseConsultorias() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterEventosPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarEvento', response.data),
                        this.$emit('receberAcao', this.acao)
                    } else {
                        this.$toast.error(
                            'Erro ao obter os eventos da ação.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            
            ConveniosServicos.obterConsultoriasPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarConsultoria', response.data),
                        this.$emit('receberAcao', this.acao)
                    } else {
                        this.$toast.error(
                            'Erro ao obter os consultorias da ação.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}
</script>
